module.exports = __webpack_public_path__ + "static/media/icon_calculator_active.18b0aff3.svg";